module.exports = __webpack_public_path__ + "static/imp-logo-fb37cd0299b2c4d2b087284c62116679.png";